<template>{{ asText }}</template>

<script setup lang="ts">
import { Duration } from 'luxon'
import { computed, toRefs } from 'vue'

const props = defineProps<{
	duration: Duration | null
	short?: boolean
}>()

const { duration, short } = toRefs(props)

const durationRoundedToHours = computed(() => {
	if (!duration.value) {
		return duration.value
	}

	return Duration.fromObject({ hours: Math.round(duration.value.as('hours')) }).shiftTo('days', 'hours', 'minutes')
})

function getPart(label: string, value?: number) {
	const rounded = value ? Math.round(value) : 0

	if (rounded) {
		return `${rounded} ${label}${rounded > 1 ? 's' : ''}`
	}
}

const asText = computed(() =>
	!durationRoundedToHours.value || !durationRoundedToHours.value.isValid
		? ''
		: [
				getPart('day', durationRoundedToHours.value.days),
				getPart(short.value ? 'hr' : 'hour', durationRoundedToHours.value.hours),
				getPart(short.value ? 'min' : 'minute', durationRoundedToHours.value.minutes)
			]
				.filter((value) => !!value)
				.join(', ') || 'Too short'
)
</script>
